import { useState, useMemo } from "react";
import { useGetBelongUsersByFirmIDQuery } from "../store/storageRoles/firmApi";

export function useFirmUsersData({ id, token }) {
  const [paginationNumber, setPaginationNumber] = useState(1);

  const queryArg = useMemo(() => (id && token ? { id, token } : null), [id, token]);

  const {
    data: usersData,
    isLoading: usersIsLoading,
    isFetching: usersIsFetching,
    error: usersError,
    refetch: refetchFirmUsers,
  } = useGetBelongUsersByFirmIDQuery(
    queryArg,
    {
      refetchOnMountOrArgChange: true,
      skip: !queryArg,
    }
  );

  const users = useMemo(() => usersData?.data?.users || [], [usersData]);

  const isLoading = usersIsLoading || usersIsFetching;
  const hasNoData = usersData?.results === 0 || usersError;

  return {
    users,
    isLoading,
    hasNoData,
    usersError,
    paginationNumber,
    setPaginationNumber,
    refetch: refetchFirmUsers,
  };
}
